import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import { businessDivisions } from '@/mocks/homeData';

export default function BusinessDivisions() {
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="w-full px-6 md:px-10 lg:px-16">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14 md:mb-20"
        >
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-accent-600 mb-4">
            What We Do
          </span>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 mb-5 uppercase tracking-tight">
            Our Services
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            Five specialized divisions delivering end-to-end trade, procurement, and logistics solutions across Africa, the Middle East, and Asia.
          </p>
        </motion.div>

        {/* Service Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {businessDivisions.map((division, index) => (
            <motion.div
              key={division.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Link
                to={division.href}
                className="group block bg-background-50 border border-background-200/70 rounded-2xl p-8 md:p-10 hover:border-accent-300/40 hover:shadow-lg hover:shadow-primary-500/5 transition-all duration-400 cursor-pointer h-full"
              >
                {/* Icon */}
                <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-primary-900 text-accent-400 mb-6 group-hover:bg-accent-500 group-hover:text-primary-900 transition-all duration-400">
                  <i className={`${division.icon} text-2xl`}></i>
                </div>

                {/* Title */}
                <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors duration-300 uppercase tracking-wide">
                  {division.title}
                </h3>

                {/* Description */}
                <p className="text-sm text-foreground-500 leading-relaxed mb-6">
                  {division.description}
                </p>

                {/* READ MORE link — Helmora style */}
                <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-accent-600 group-hover:text-accent-500 transition-all duration-300">
                  <span>Read More</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-300"></i>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}